import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import CssBaseline from '@mui/material/CssBaseline';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Box,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  CardContent,
} from '@mui/material';
import AppBarMenu from '../components/appBarMenu';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import dayjs from 'dayjs';
import apiService, { Payment } from '../services/api.service';
import MyTable from '../components/MyTable';


const Dashboard = () => {
  const navigate = useNavigate();
  const { user, isLogged } = useSelector((state: RootState) => state.auth);
  
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(dayjs().subtract(1, 'month').toDate());
  const [endDate, setEndDate] = useState<Date | null>(dayjs().toDate());
  const [payments, setPayments] = useState<Payment[]>([]);
  const [seeInformationAs, setSeeInformationAs] = useState<"grid" | "card">("card");
  
  const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
  const [openPdfModal, setOpenPdfModal] = useState(false);

  useEffect(() => {
    if (!isLogged) {
      navigate('/login');
    }
  }, [isLogged, navigate]);

  useEffect(() => {
    if (user && startDate && endDate && !loading) {
      loadBoletas();
    }
    // eslint-disable-next-line 
  }, [user, startDate, endDate]);

  const loadBoletas = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const response = await apiService.getMyPayments();
      
      setPayments(response.payments);
    } catch (error) {
      console.error('Error cargando boletas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewPdf = (url: string) => {
    setSelectedPdf(url);
    setOpenPdfModal(true);
  };

  const handleClosePdf = () => {
    setOpenPdfModal(false);
    setSelectedPdf(null);
  };
  
  const tableHeadRows = [
    {
        label: "Tipo",
        rowKeyName: "documentTypeLabel",
    },{
        label: "Periodo",
        rowKeyName: "periodLabel",
    },{
        label: "Ruc",
        rowKeyName: "companyRuc",
    },{
        label: "Empresa",
        rowKeyName: "companyName",
    },{
        label: "",
        rowKeyName: "download",
        customValue: (headRow: any, row: any) => {
          return <Grid
              container 
              justifyContent="space-between" 
              direction="row"
              style={{minWidth: row.FirmadoRespuesta ? "11rem" : "7rem"}}
          >
              
            <IconButton
              color="primary"
              onClick={() => handleViewPdf(row.url)}
              size="small"
            >
              <VisibilityIcon />
            </IconButton>
          </Grid>
        }
    }
  ]

  console.log('---- payments', payments)

  return (
    <Box sx={{ display: 'flex', minHeight: '100%', backgroundColor: '#F5F5F5', width: '100%' }}>
      <CssBaseline />
      {user && <AppBarMenu />}
      
      <Grid 
        container 
        direction="row"
        alignItems="flex-start"
        spacing={0}
        padding="4rem 0 2rem 0" 
        sx={{
          backgroundColor: '#F5F5F5',
          minHeight: '100vh',
          width: '100%',
        }}
      >

        <Grid 
          container 
          direction="row"
          alignItems="flex-start"
          sx={{
            backgroundColor: '#F5F5F5',
            width: '100%',
            padding:'0 1.5rem'
          }}
        >


          <Grid item xs={12}>
            <Paper elevation={2} sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px', padding:'0 1rem' }}>
            <MyTable
                key="tab-0"
                rangeControlProps={{
                  startDate: startDate,
                  endDate: endDate,
                  setEndDate: setEndDate,
                  setStartDate: setStartDate,
                }}
                // pageNumber={page}
                itemsPerPage={20}
                seeInformationAs={seeInformationAs}
                setSeeInformationAs={setSeeInformationAs}
                // totalItems={totalItems}
                // totalPages={totalItems / pageSize}
                // onChangePageNumber={setPage}
                // onChangeItemsPerPage={setPageSize}
                hiddenSearchInput={true}
                tableHeadRows={tableHeadRows}
                // hiddenFilterOptions={hiddenFilterOptions}
                tableRows={payments}
                loading={loading}
                cardComponent={{
                  cardContent: (row) => {
                    return (
                      <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                          <Grid item xs>
                            <Typography variant="h6" color="text.primary" marginBottom=".2rem">
                              {row.documentTypeLabel}
                            </Typography>
                          </Grid>
                          <Grid item maxWidth="2rem">
                            <IconButton
                              color="primary"
                              onClick={() => handleViewPdf(row.url)}
                              size="small"
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                        <Typography variant="body1" style={{marginTop: ".2rem", fontSize: '14px'}}>
                          Período: {" "}
                          <Typography variant="body2" component="span" style={{fontSize: '14px'}}>
                            {row.periodLabel}
                          </Typography>
                        </Typography>
                        <Typography variant="body1" style={{marginTop: ".2rem", fontWeight: "bold", fontSize: '14px'}}>
                          RUC: {" "}
                          <Typography variant="body2" component="span" style={{fontWeight: "bold", fontSize: '14px'}}>
                            {row.companyRuc || ""}
                          </Typography>
                        </Typography>
                        <Typography variant="body1" style={{marginTop: ".2rem", fontWeight: "bold", fontSize: '14px'}}>
                          Empresa: {" "}
                          <Typography variant="body2" component="span" style={{fontWeight: "bold", fontSize: '14px'}}>
                            {row.companyName}
                          </Typography>
                        </Typography>
                      </CardContent>
                    );
                  },
                  // numberOfCards: 4,
                  changeViewOptionHidden: false,
                }}
                tableOptionsBar={{
                    useDrawer: false,
                }}
                hiddenFilterOptions={true}
                hiddenBottomPaginator={false}
                hiddenItemsPerPage={true}
            />
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={openPdfModal}
        onClose={handleClosePdf}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { height: '90vh', borderRadius: '8px' }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* <PictureAsPdfIcon color="error" /> */}
            <Typography variant="h6">Vista previa</Typography>
          </Box>
          <IconButton onClick={handleClosePdf} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedPdf && (
            <iframe
              src={selectedPdf}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="Vista previa PDF"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePdf} variant="outlined">
            Cerrar
          </Button> 
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Dashboard;